import { TinyDropDownOption } from '.';

export function getOptionText(option?: TinyDropDownOption) {
  if (option) {
    return option.label || option.value;
  }
}
